module.exports =
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // identity function for calling harmony imports with the correct context

  /******/

  __webpack_require__.i = function (value) {
    return value;
  };
  /******/

  /******/
  // define getter function for harmony exports

  /******/


  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        /******/
        configurable: false,

        /******/
        enumerable: true,

        /******/
        get: getter
        /******/

      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = 36);
  /******/
}
/************************************************************************/

/******/
([
/* 0 */

/***/
function (module, exports) {
  module.exports = require("react");
  /***/
},
/* 1 */

/***/
function (module, exports, __webpack_require__) {
  var arrayWithHoles = __webpack_require__(16);

  var iterableToArrayLimit = __webpack_require__(19);

  var unsupportedIterableToArray = __webpack_require__(7);

  var nonIterableRest = __webpack_require__(20);

  function _slicedToArray(arr, i) {
    return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
  }

  module.exports = _slicedToArray;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  /***/
},
/* 2 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__button_utils__ = __webpack_require__(37);
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "i", function () {
    return __WEBPACK_IMPORTED_MODULE_0__button_utils__["a"];
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__flexbox_utils__ = __webpack_require__(39);
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "j", function () {
    return __WEBPACK_IMPORTED_MODULE_1__flexbox_utils__["a"];
  });
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "k", function () {
    return __WEBPACK_IMPORTED_MODULE_1__flexbox_utils__["b"];
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__key_codes__ = __webpack_require__(43);
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "l", function () {
    return __WEBPACK_IMPORTED_MODULE_2__key_codes__["a"];
  });
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "m", function () {
    return __WEBPACK_IMPORTED_MODULE_2__key_codes__["b"];
  });
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "n", function () {
    return __WEBPACK_IMPORTED_MODULE_2__key_codes__["c"];
  });
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "o", function () {
    return __WEBPACK_IMPORTED_MODULE_2__key_codes__["d"];
  });
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "p", function () {
    return __WEBPACK_IMPORTED_MODULE_2__key_codes__["e"];
  });
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "q", function () {
    return __WEBPACK_IMPORTED_MODULE_2__key_codes__["f"];
  });
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "r", function () {
    return __WEBPACK_IMPORTED_MODULE_2__key_codes__["g"];
  });
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "s", function () {
    return __WEBPACK_IMPORTED_MODULE_2__key_codes__["h"];
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__make_enum__ = __webpack_require__(44);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__is_function__ = __webpack_require__(41);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__is_in_ie__ = __webpack_require__(42);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__round_to_decimals__ = __webpack_require__(45);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__is_on_server__ = __webpack_require__(11);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8__caret_position__ = __webpack_require__(38);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9__get_window_width__ = __webpack_require__(40);
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "a", function () {
    return __WEBPACK_IMPORTED_MODULE_3__make_enum__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "b", function () {
    return __WEBPACK_IMPORTED_MODULE_4__is_function__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "c", function () {
    return __WEBPACK_IMPORTED_MODULE_5__is_in_ie__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "d", function () {
    return __WEBPACK_IMPORTED_MODULE_6__round_to_decimals__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "e", function () {
    return __WEBPACK_IMPORTED_MODULE_7__is_on_server__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "f", function () {
    return __WEBPACK_IMPORTED_MODULE_8__caret_position__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "g", function () {
    return __WEBPACK_IMPORTED_MODULE_8__caret_position__["b"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "h", function () {
    return __WEBPACK_IMPORTED_MODULE_9__get_window_width__["a"];
  });
  /***/

},
/* 3 */

/***/
function (module, exports) {
  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  module.exports = _defineProperty;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  /***/
},
/* 4 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
  /**
   * Checks if component is unmounted
   * Note that it does not actively trigger component re-render
   * 
   * Use this hook if there is setState called async in useEffect 
   * (typically after api call or setTimeout), as rendering an 
   * unmounted component can lead to memory leaks. We want to
   * ensure that the component is still mounted when it re-renders
   * (as a result of state change).
   * 
   * Note that alternatively we could use RxJS to cancel asycn events
   * in the returned function of useEffect(()=> { return a function }, [])
   * 
   * https://www.digitalocean.com/community/tutorials/how-to-handle-async-data-loading-lazy-loading-and-code-splitting-with-react 
   */


  var useIsUnmounted = function useIsUnmounted() {
    // does not actively trigger re-render as useState
    var isUnmountedRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(false);

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
      return function () {
        return isUnmountedRef.current = true;
      };
    }, []); // Using an empty dependency array ensures this only runs on unmount


    return isUnmountedRef;
  };
  /* harmony default export */


  __webpack_exports__["a"] = useIsUnmounted;
  /***/
},
/* 5 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

  var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"];
  /* harmony default export */

  __webpack_exports__["a"] = useIsomorphicLayoutEffect;
  /***/
},
/* 6 */

/***/
function (module, exports) {
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }

  module.exports = _arrayLikeToArray;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  /***/
},
/* 7 */

/***/
function (module, exports, __webpack_require__) {
  var arrayLikeToArray = __webpack_require__(6);

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
  }

  module.exports = _unsupportedIterableToArray;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  /***/
},
/* 8 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__use_is_unmounted__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(2); // TODO: Use this to replace setTimeout and useIsUnmounted in the code base


  var useEffectSkipTick = function useEffectSkipTick(fn, depList, milliseconds) {
    var isUnmountedRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__use_is_unmounted__["a"
    /* default */
    ])();

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
      // Component can be unmounted by the time setTimeOut triggers
      var timer = setTimeout(function () {
        if (!isUnmountedRef.current && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["b"
        /* isFunction */
        ])(fn)) {
          fn();
        }
      }, milliseconds);
      return function () {
        return clearTimeout(timer);
      };
    }, depList);
  };
  /* harmony default export */


  __webpack_exports__["a"] = useEffectSkipTick;
  /***/
},
/* 9 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);

  var useForceUpdate = function useForceUpdate() {
    var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),
        _useState2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
        update = _useState2[1];

    var forceUpdate = function forceUpdate() {
      return update(function (value) {
        return !value;
      });
    };

    return forceUpdate;
  };
  /* harmony default export */


  __webpack_exports__["a"] = useForceUpdate;
  /***/
},
/* 10 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(2);
  /**
   * Runs a function only once (during the component's first render)
   * It can also be reset so that the function can be called once again 
   */


  var useRunOnce = function useRunOnce(fn, reset) {
    // value of `reset` will be {}
    var hasRun = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(false);

    var resetRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();

    var isReset = false;

    if (reset && resetRef.current !== reset) {
      // if it is a NEW reset request 
      hasRun.current = false;
      resetRef.current = reset;
      isReset = true;
    }

    if (!hasRun.current && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["b"
    /* isFunction */
    ])(fn)) {
      // call `fn` and tells it if it's called as a result of reset
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["b"
      /* isFunction */
      ])(fn) && fn(isReset);
      hasRun.current = true;
    }
  };
  /* harmony default export */


  __webpack_exports__["a"] = useRunOnce;
  /***/
},
/* 11 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony default export */

  __webpack_exports__["a"] = function () {
    return typeof window === 'undefined';
  }; // for SSR

  /***/

},
/* 12 */

/***/
function (module, exports) {
  module.exports = require("debounce");
  /***/
},
/* 13 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__alert_context_provider__ = __webpack_require__(23);
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "a", function () {
    return __WEBPACK_IMPORTED_MODULE_0__alert_context_provider__["a"];
  });
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "b", function () {
    return __WEBPACK_IMPORTED_MODULE_0__alert_context_provider__["b"];
  });
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "c", function () {
    return __WEBPACK_IMPORTED_MODULE_0__alert_context_provider__["c"];
  });
  /***/

},
/* 14 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__use_svg_scale__ = __webpack_require__(31);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__use_force_update__ = __webpack_require__(9);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__use_pressed_state__ = __webpack_require__(26);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__use_query_params__ = __webpack_require__(27);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__use_run_once__ = __webpack_require__(10);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__use_validator__ = __webpack_require__(34);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__use_is_unmounted__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__use_is_mounted__ = __webpack_require__(25);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8__use_unique_id__ = __webpack_require__(33);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9__use_window_size__ = __webpack_require__(35);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_10__use_effect_skip_tick__ = __webpack_require__(8);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_11__use_set_focus__ = __webpack_require__(30);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_12__use_underlying_error__ = __webpack_require__(32);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_13__use_debounce__ = __webpack_require__(24);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_14__use_render_on_top__ = __webpack_require__(28);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_15__use_scroll_to_screen_top__ = __webpack_require__(29);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_16__use_isomorphic_layout_effect__ = __webpack_require__(5);
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "a", function () {
    return __WEBPACK_IMPORTED_MODULE_0__use_svg_scale__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "b", function () {
    return __WEBPACK_IMPORTED_MODULE_1__use_force_update__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "c", function () {
    return __WEBPACK_IMPORTED_MODULE_2__use_pressed_state__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "d", function () {
    return __WEBPACK_IMPORTED_MODULE_3__use_query_params__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "e", function () {
    return __WEBPACK_IMPORTED_MODULE_4__use_run_once__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "f", function () {
    return __WEBPACK_IMPORTED_MODULE_5__use_validator__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "g", function () {
    return __WEBPACK_IMPORTED_MODULE_6__use_is_unmounted__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "h", function () {
    return __WEBPACK_IMPORTED_MODULE_7__use_is_mounted__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "i", function () {
    return __WEBPACK_IMPORTED_MODULE_8__use_unique_id__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "j", function () {
    return __WEBPACK_IMPORTED_MODULE_9__use_window_size__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "k", function () {
    return __WEBPACK_IMPORTED_MODULE_9__use_window_size__["b"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "l", function () {
    return __WEBPACK_IMPORTED_MODULE_10__use_effect_skip_tick__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "m", function () {
    return __WEBPACK_IMPORTED_MODULE_11__use_set_focus__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "n", function () {
    return __WEBPACK_IMPORTED_MODULE_12__use_underlying_error__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "o", function () {
    return __WEBPACK_IMPORTED_MODULE_13__use_debounce__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "p", function () {
    return __WEBPACK_IMPORTED_MODULE_14__use_render_on_top__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "q", function () {
    return __WEBPACK_IMPORTED_MODULE_15__use_scroll_to_screen_top__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "r", function () {
    return __WEBPACK_IMPORTED_MODULE_16__use_isomorphic_layout_effect__["a"];
  });
  /***/

},
/* 15 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return accessibleHiddenStyle;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "b", function () {
    return fixedAccessibleHiddenStyle;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  } // makes the elememt hidden while still accessible


  var accessibleHiddenStyle = {
    position: 'absolute',
    zIndex: -1,
    opacity: 0,
    outline: 'none',
    left: 0,
    top: 0
  };

  var fixedAccessibleHiddenStyle = _objectSpread(_objectSpread({}, accessibleHiddenStyle), {}, {
    position: 'fixed'
  });
  /***/

},
/* 16 */

/***/
function (module, exports) {
  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  module.exports = _arrayWithHoles;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  /***/
},
/* 17 */

/***/
function (module, exports, __webpack_require__) {
  var arrayLikeToArray = __webpack_require__(6);

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return arrayLikeToArray(arr);
  }

  module.exports = _arrayWithoutHoles;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  /***/
},
/* 18 */

/***/
function (module, exports) {
  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }

  module.exports = _iterableToArray;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  /***/
},
/* 19 */

/***/
function (module, exports) {
  function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;

    var _s, _e;

    try {
      for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  module.exports = _iterableToArrayLimit;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  /***/
},
/* 20 */

/***/
function (module, exports) {
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  module.exports = _nonIterableRest;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  /***/
},
/* 21 */

/***/
function (module, exports) {
  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  module.exports = _nonIterableSpread;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  /***/
},
/* 22 */

/***/
function (module, exports, __webpack_require__) {
  var arrayWithoutHoles = __webpack_require__(17);

  var iterableToArray = __webpack_require__(18);

  var unsupportedIterableToArray = __webpack_require__(7);

  var nonIterableSpread = __webpack_require__(21);

  function _toConsumableArray(arr) {
    return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
  }

  module.exports = _toConsumableArray;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  /***/
},
/* 23 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return AlertContextProvider;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "b", function () {
    return AlertContext;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "c", function () {
    return AlertContextConsumer;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);

  var AlertContext = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createContext();

  var AlertContextConsumer = AlertContext.Consumer;
  /**
   * React context for Alert components
   * 
   * Note that `@tal-gel/core` must be a peer dependency of other @tal-gel modules (See package.json),
   * and must not be bundled together with any of them (See webpack config)
   * 
   * This is to ensure that the client project and other @tal-gel modules use the same `AlertContext`,
   * as `AlertContext`s from different locations will have different keys, causing consumers not to be
   * able to find the matching provider
   * 
   * If from the same location, the `AlertContext` returned from the first execution of this file 
   * will be cached and reused
   */

  var AlertContextProvider = function AlertContextProvider(props) {
    var nextIndexOfAlert = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(-1);

    var indexOfAlertRemovedRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(-1);

    var heightOfAlertRemovedRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(0);

    var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(),
        _useState2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
        contextShouldChange = _useState2[0],
        setContextShouldChange = _useState2[1];

    var context = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react__["useMemo"])(function () {
      // Prevent getting a new context object each time causing unnecessary re-renders of consumers
      // In this case, unnecessary re-renders of consumers could even cause bugs as `Alert` component
      // has a `useEffect` based on whether the context object changes or not
      return {
        addAlert: function addAlert() {
          nextIndexOfAlert.current++; // +1, for the added alert

          indexOfAlertRemovedRef.current = -1; // reset

          heightOfAlertRemovedRef.current = 0; // reset

          return nextIndexOfAlert.current; // index to be assigned to the alert just added
        },
        indexOfAlertRemoved: indexOfAlertRemovedRef.current,
        // index of the alert just removed
        heightOfAlertRemoved: heightOfAlertRemovedRef.current,
        // height of the alert just removed
        removeAlert: function removeAlert(height, index) {
          nextIndexOfAlert.current--; // -1, for the removed alert

          heightOfAlertRemovedRef.current = height; // store height of the removed alert, to be checked by other alerts to determine if they need to adjust their positions

          indexOfAlertRemovedRef.current = index; // store index of the removed alert, to be checked by other alerts to determine if they need to adjust their positions

          setContextShouldChange({}); // `{}` generates a new object each time, forcing a Provider re-render
        }
      };
    }, [contextShouldChange]); // `{}` generates a new object each time, so `setContextShouldChange({})` also makes `useMemo` return a new Context


    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AlertContext.Provider, {
      value: context
    }, props.children);
  };
  /***/

},
/* 24 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_debounce__ = __webpack_require__(12);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_debounce__);

  var useDebounce = function useDebounce(fn) {
    var debounceTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;

    var debouncedFnRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
      debouncedFnRef.current = __WEBPACK_IMPORTED_MODULE_1_debounce___default()(fn, debounceTime);
      return function () {
        if (debouncedFnRef.current) {
          debouncedFnRef.current.clear();
        }
      };
    }, []);

    return debouncedFnRef;
  };
  /* harmony default export */


  __webpack_exports__["a"] = useDebounce;
  /***/
},
/* 25 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
  /**
   * Added for the sake of SSR/SSG 
   * https://www.joshwcomeau.com/react/the-perils-of-rehydration/
   * 
   * The client-side JS includes the same React code used to generate 
   * it at compile-time. It runs on the user's device, and builds up a 
   * picture of what the world should look like. It then compares it to 
   * the HTML built into the document. This is a process known as rehydration.
   * 
   * Critically, rehydration is not the same thing as a render. In a typical render, 
   * when props or state change, React is prepared to reconcile any differences 
   * and update the DOM. In a rehydration, React assumes that the DOM won't change. 
   * It's just trying to adopt the existing DOM.
   * 
   * Two-pass render
   * The first pass happens at compile-time, wayyy ahead of time, and sets 
   * the foundation for the page, filling in everything that is universal 
   * for all users. Then, much later, a second-pass render will fill in 
   * the stateful bits that vary from person to person.
   * 
   * https://github.com/facebook/react/issues/11128#issuecomment-386223307
   * Also read https://reactjs.org/link/uselayouteffect-ssr
   */


  var useIsMounted = function useIsMounted() {
    var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),
        _useState2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
        isMounted = _useState2[0],
        setIsMounted = _useState2[1]; // useLayoutEffect (without state change) -> browser paints -> useEffect
    // useLayoutEffect (with state change) -> browser does NOT paint -> useEffect
    // 
    // In the case of hydration, it doesn't matter if it is useEffect
    // or useLayoutEffect, because in prod Next.js sets all script 
    // loading to be async so browser can render HTML prior to scripts 
    // (eg: React) kicking in. Consequently, if the HTML generated from 
    // SSR/SSG isn't 100% correct due to screen size, that HTML will 
    // be made visible in the browser anyway before useLayoutEffect
    // could kick in. Also read:
    // https://stackoverflow.com/questions/10808109/script-tag-async-defer
    //
    // Therefore, GEL components (if used with GelScreenDetector) may not
    // work well with Next.js, as the SSR/SSG generated HTML may not look
    // 100% correct when loaded in the browser, until React code also loads 
    // and executes. A shell or loader could be used to "cover" the not-100%-
    // correct HTML until React code kicks in. However, care should be taken 
    // not to replace the HTML entirely with shell or loader as it would 
    // impact SEO. 
    //
    // Media queries might still be better in this respect as modern browsers
    // will prioritise to load css so by the time browser renders the HTML
    // for the first time it will already have css loaded. So things would 
    // look correct under the current screen size from the start.
    //
    // However, media queries may still not be ideal for GEL components if
    // we want components to have high level of configurability in responsiveness.
    // As mentioned above, we can't use JS to detect screen sizes if we want
    // SSR/SSG to work the best. That means that to configure responsiveness,
    // users would have to use media queries to style the underlying elements
    // of GEL components. This couples users with the implementation of GEL
    // components, and will also make component "interfaces" hard to use (in
    // fact no interfaces as this breaks encapsulation of components) compared 
    // to assiging different values to props via JS when the current screen size 
    // is determined in JS.
    //
    // Is this a dilemma?
    //
    // Use JS to detect screen: 
    // HTML from SSR/SSG may look incorrect at first until JS loads and two-pass 
    // render completes
    //
    // Use mediua queries (When HTML from SSR/SSG first loads, there is only
    // HTML and CSS in place, but no JS): 
    // This means that media queries would need to target the underlying elements
    // of GEL components. Therefore, it breaks encapsulation of components, and
    // it's harder to apply (no intefaces like props) and hard to maintain in 
    // the long run.
    //
    // Perhaps we can create mixins to encapulate underlying elements of GEL
    // components and allow users to configure responsiveness via mixins.. But
    // can we target individual instances of the same component that way, while
    // still keeping good encapsulation?


    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
      setIsMounted(true);
    }, []);

    return isMounted;
  };
  /* harmony default export */


  __webpack_exports__["a"] = useIsMounted;
  /***/
},
/* 26 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__); // TODO: Knowledge sharing idea: what's behind scene of useState, 
  // useMemo and useCallback, etc.

  /**
   * Custom hook to manage the pressed state of button
   * Pressed state is when a button "has been" clicked
   */


  var usePressedState = function usePressedState(_ref) {
    var onClick = _ref.onClick,
        onBlur = _ref.onBlur;

    var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),
        _useState2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
        pressed = _useState2[0],
        setPressed = _useState2[1];
    /**
     * The callback function passed into useCallback only has access to
     * variable values in the closure where this function is defined
     * 
     * If variable values have changed in the new closure and if we want
     * the callback function to be able to access the new values,
     * we can specify dependencies in [], so useCallback will return the callback function
     * defined in the new closure (thus it will have access to variable values in the new closure)
     * 
     * Otherwise, useCallback will always return the callback function defined in the very initial
     * closure (for example, when usePressedState is called for the first time), so only values in the
     * initial closure can be accessed by that callback function. This may cause bugs
     * if the callback function relies on variables in the clousure whose values may change.
     * So specify dependencies in [] when needed.
     * 
     * BE FULLY AWARE OF THE SCOPE IMPLICATIONS WHEN USING useCallback
     */


    var onPress = function onPress(event) {
      setPressed(true); // invoke custom click handler if provided

      onClick && onClick(event);
    };

    var onUnpress = function onUnpress(event) {
      var invokeCustom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      setPressed(false); // invoke custom blur handler if provided AND if asked to

      invokeCustom && onBlur && onBlur(event);
    };

    return [pressed, onPress, onUnpress, setPressed];
  };
  /* harmony default export */


  __webpack_exports__["a"] = usePressedState;
  /***/
},
/* 27 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(50);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_react_router_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__);

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }
  /**
   * Custom hook to make it easier to access query params in the url
   * Once location info changes, component will be marked for re-render,
   * so the component will get the updated query info.
   */


  var useQueryParams = function useQueryParams() {
    // https://reactrouter.com/web/api/Hooks
    // https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["useLocation"])().search.slice(1).split('&').reduce(function (result, current) {
      var labelAndValue = current.split('=');
      return _objectSpread(_objectSpread({}, result), {}, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, labelAndValue[0], labelAndValue[1]));
    }, {});
  };
  /* harmony default export */


  __webpack_exports__["a"] = useQueryParams;
  /***/
},
/* 28 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__use_isomorphic_layout_effect__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__use_force_update__ = __webpack_require__(9);

  var useRenderOnTop = function useRenderOnTop(_ref) {
    var _ref$PageLayoutContex = _ref.PageLayoutContext,
        PageLayoutContext = _ref$PageLayoutContex === void 0 ? {} : _ref$PageLayoutContex,
        _ref$extraHeightToAvo = _ref.extraHeightToAvoid,
        extraHeightToAvoid = _ref$extraHeightToAvo === void 0 ? 0 : _ref$extraHeightToAvo;

    var targetRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();

    var shouldRenderOnTop = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(false);

    var forceUpdate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__use_force_update__["a"
    /* default */
    ])();

    var pageLayoutContext = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(PageLayoutContext);

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__use_isomorphic_layout_effect__["a"
    /* default */
    ])(function () {
      // Do not paint until we have decided which side (top or bottom)
      if (targetRef.current && !shouldRenderOnTop.current) {
        // Check if there is enough space at the bottom.
        // If not, render at the top instead
        shouldRenderOnTop.current = targetRef.current.getBoundingClientRect().bottom > window.innerHeight - (pageLayoutContext ? pageLayoutContext.getFooterHeightAsBoundary() + extraHeightToAvoid : extraHeightToAvoid);

        if (shouldRenderOnTop.current) {
          forceUpdate();
        }
      }
    });
    /**
     * Component re-renders -> useLayoutEffect -> brower repaints -> useEffect
     * 
     * useEffect will always be called no matter what we do in useLayoutEffect
     * 
     * However, if state changes asynchronously (eg: in forceUpdate) 
     * in useLayoutEffect, browser does not seem to repaint with the 
     * current state before useEffect is called.
     * 
     * On the other hand, if state changes asynchronously (eg: in forceUpdate) 
     * in useEffect, browser does repaint with the current state before
     * useEffect is called.
     */
    // Always start by checking bottom for each next render


    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
      if (shouldRenderOnTop.current) {
        var timer = setTimeout(function () {
          shouldRenderOnTop.current = false;
          clearTimeout(timer);
        });
      }
    });

    var getTargetHeight = function getTargetHeight() {
      return targetRef.current ? targetRef.current.offsetHeight : 0;
    };

    return {
      targetRef: targetRef,
      shouldRenderOnTop: shouldRenderOnTop.current,
      getTargetHeight: getTargetHeight
    };
  };
  /* harmony default export */


  __webpack_exports__["a"] = useRenderOnTop;
  /***/
},
/* 29 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
  /**
   * Typically used without PageLayout, 
   * as with PageLayout it is the content 
   * section that scrolls.
   */


  var useScrollToScreenTop = function useScrollToScreenTop() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
      // Scroll to the top (cross-browser)
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }, []);
  };
  /* harmony default export */


  __webpack_exports__["a"] = useScrollToScreenTop;
  /***/
},
/* 30 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

  var useSetFocus = function useSetFocus(_ref) {
    var focusOnMount = _ref.focusOnMount,
        focusOnRequest = _ref.focusOnRequest,
        inputRef = _ref.inputRef,
        setPressed = _ref.setPressed;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
      // Check if input needs to have focus right after mount
      if (focusOnMount && inputRef.current) {
        inputRef.current.focus();
      }
    }, []);

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
      // Sets focus on the input when requested
      if (focusOnRequest && inputRef.current) {
        setPressed(true);
        inputRef.current.focus();
      }
    }, [focusOnRequest]); // focusOnRequest receives {}

  };
  /* harmony default export */


  __webpack_exports__["a"] = useSetFocus;
  /***/
},
/* 31 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__use_isomorphic_layout_effect__ = __webpack_require__(5);

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  } // TODO: Check if this needs to be used at all in button

  /**
   * Custom hook to scale the svg
   * 
   * width: target width to scale to
   * height: target height to scale to
   */


  var useSvgScale = function useSvgScale(_ref) {
    var width = _ref.width,
        height = _ref.height;

    var svgRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["useRef"])();

    var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])({}),
        _useState2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
        scale = _useState2[0],
        setScale = _useState2[1];

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__use_isomorphic_layout_effect__["a"
    /* default */
    ])(function () {
      if (svgRef.current && svgRef.current.width && svgRef.current.height) {
        // available after first mount
        // original width of svg
        var orignalWidth = svgRef.current.width.baseVal.value; // original height of svg

        var orignalHeight = svgRef.current.height.baseVal.value;
        setScale(_objectSpread(_objectSpread({}, (width || height) && {
          width: width || null,
          height: height || null
        }), {}, {
          viewBox: "0 0 ".concat(orignalWidth, " ").concat(orignalHeight)
        }));
      }
    }, []);

    return [svgRef, scale];
  };
  /* harmony default export */


  __webpack_exports__["a"] = useSvgScale;
  /***/
},
/* 32 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(2);
  /**
   * Ensures that both the wrapping and wrapped components 
   * only notify of their own respective error(s), to avoid
   * duplicate error notifications.
   */


  var useUnderlyingError = function useUnderlyingError(onError) {
    var underlyingError = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(); // onError handler to be used by the wrapped/underlying component


    var onErrorUnderlying = function onErrorUnderlying(error) {
      // `error` being `true` means that the error is from the wrapping component
      if (error && error !== true && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["b"
      /* isFunction */
      ])(onError)) {
        // Only notify parent of this error if the error is
        // from the underlying component
        onError(error);
      }

      underlyingError.current = error;
    }; // onError handler to be used by the wrapping component


    var onErrorWrapping = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["b"
    /* isFunction */
    ])(onError) && function (error) {
      if (!error && !underlyingError.current) {
        // Notify parent of no error, only if both the underlying 
        // and wrapping components do not have error
        onError(false);
      } else if (error) {
        // Notify parent of the error coming from the wrapping component
        onError(error);
      }
    };

    return {
      onErrorUnderlying: onErrorUnderlying,
      onErrorWrapping: onErrorWrapping
    };
  };
  /* harmony default export */


  __webpack_exports__["a"] = useUnderlyingError;
  /***/
},
/* 33 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_uuid_v4__ = __webpack_require__(48);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_uuid_v4__);

  function _createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

    if (!it) {
      if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;

        var F = function F() {};

        return {
          s: F,
          n: function n() {
            if (i >= o.length) return {
              done: true
            };
            return {
              done: false,
              value: o[i++]
            };
          },
          e: function e(_e) {
            throw _e;
          },
          f: F
        };
      }

      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    var normalCompletion = true,
        didErr = false,
        err;
    return {
      s: function s() {
        it = it.call(o);
      },
      n: function n() {
        var step = it.next();
        normalCompletion = step.done;
        return step;
      },
      e: function e(_e2) {
        didErr = true;
        err = _e2;
      },
      f: function f() {
        try {
          if (!normalCompletion && it["return"] != null) it["return"]();
        } finally {
          if (didErr) throw err;
        }
      }
    };
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }

  var useUniqueId = function useUniqueId() {
    var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    var uniqueId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(); // Only generate unique ID(s) if not yet generated


    if (!uniqueId.current) {
      if (amount === 1) {
        // If asked to return 1 unique ID
        uniqueId.current = __WEBPACK_IMPORTED_MODULE_1_uuid_v4___default()();
      } else if (amount > 1) {
        // If asked to return multiple unique IDs
        uniqueId.current = [];

        var _iterator = _createForOfIteratorHelper(Array(amount)),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var i = _step.value;
            uniqueId.current.push(__WEBPACK_IMPORTED_MODULE_1_uuid_v4___default()());
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }

    return uniqueId.current;
  };
  /* harmony default export */


  __webpack_exports__["a"] = useUniqueId;
  /***/
},
/* 34 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(22);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(2);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__use_run_once__ = __webpack_require__(10);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__use_is_unmounted__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__use_effect_skip_tick__ = __webpack_require__(8);

  var useValidator = function useValidator(props) {
    // whether the component has been `touched` (used to determine whether to show error)
    // A field is considered touched after it has got focus and then lost focus for at least once
    var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(false),
        _useState2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
        touched = _useState2[0],
        setTouched = _useState2[1]; // internal error status (note that `props.error` is the controlled error)


    var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(false),
        _useState4 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_useState3, 2),
        error = _useState4[0],
        setError = _useState4[1]; // whether to hide the internal error regardless of `touched`


    var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(props.hideErrorInitially),
        _useState6 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_useState5, 2),
        hideError = _useState6[0],
        setHideError = _useState6[1]; // whether the component is unmounted


    var isUnmountedRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__use_is_unmounted__["a"
    /* default */
    ])(); // return true if asked to check for internal error and if the value does have error


    var hasError = function hasError(value) {
      return props.checkError && props.hasError(value);
    }; // Whether onBlur has happened to this component before.
    // This is to help determine whether field error (if exists) 
    // should to be displayed after reset.


    var hasBeenOnBlurBefore = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["useRef"])(false); // Do it only once during first render, as `defaultValue` only applies to first render
    // and the subsequent changes of `defaultValue` won't be considered by React


    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__use_run_once__["a"
    /* default */
    ])(function (isReset) {
      if (isReset) {
        // if function is called as a result of reset, we reset some statuses
        if (!props.reset.keepDisplayedFieldErrors || !hasBeenOnBlurBefore.current) {
          // If we don't need to keep the displayed field errors,
          // or if it is a newly added dynamic field, we reset the 
          // component to be `untouched` so that the error (if exists) 
          // won't be displayed (See `shouldShowError`)
          setTouched(false);

          if (props.hideErrorInitially) {
            // if asked to hide the error initially
            // Hide the error, but doesn't mean it will 
            // absolutely hide it (See `shouldShowError`)
            setHideError(true);
            hasBeenOnBlurBefore.current = false;
          }
        }
      } // If the controlled `defaultValue` (no use? as it will always be controlled) has error 
      // or if the controlled `value` has error
      // (Note that in the context of GelForm, all field components must be controlled, 
      // and value will be '' if empty)


      var _error = !isControlled(props.value) && isControlled(props.defaultValue) && hasError(props.defaultValue) || isControlled(props.value) && hasError(props.value);

      if (_error) {
        setTouched(true); // mark the component `touched`

        setError(_error); // mark the component with error
        // However, it doesn't mean error will be immediately shown, as it also depends on `hideError`
      }
    }, props.reset); // value of `props.reset` is an object


    var firstValidityReport = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["useRef"])(true);

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["useEffect"])(function () {
      // TODO: Use useEffectSkipTick?
      if (props.group) {
        // if for checkbox group and radio group
        var timer = setTimeout(function () {
          if (!isUnmountedRef.current) {
            var _error = hasError();

            if (_error) {
              // if the group has error
              setTouched(true); // mark the group `touched`

              setError(_error); // mark the group with error

              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["b"
              /* isFunction */
              ])(props.onError) && props.onError(_error); // notify parent of error

              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["b"
              /* isFunction */
              ])(props.setValidity) && props.setValidity(props.index, false // report validity false to the form
              );
            } else {
              // if the group doesn't have error
              setError(false); // mark the group without error

              error && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["b"
              /* isFunction */
              ])(props.onError) && props.onError(false); // notify parent of the removal of error

              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["b"
              /* isFunction */
              ])(props.setValidity) && props.setValidity(props.index, true // report validity true to the form
              );
            }
          }

          clearTimeout(timer);
        });
      }

      firstValidityReport.current = true;
    }, [props.reset]); // value of `props.reset` is an object


    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__use_effect_skip_tick__["a"
    /* default */
    ])(function () {
      // report validity to the form
      if (!props.group || props.group && !firstValidityReport.current) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["b"
        /* isFunction */
        ])(props.setValidity) && props.setValidity(props.index, // index assigned by the form
        // Valid if both controlled error and internal error 
        // (the error that this validator checks for) are false
        !props.error && !error);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["b"
        /* isFunction */
        ])(props.onError) && props.onError(props.error || error); // notify parent of error
      }

      firstValidityReport.current = false; // Report updated validity to the form when controlled error or internal error status changes, 
      // or when asked to do reset. Not that we skip checking `touched` in this case, as we want
      // the form to be informed of field validity regardless of if the field has been touched. 
      // So, for example, the submit button can be disabled when the form is invalid, and
      // it should not be depending on if the fields have been touched.
      // `touched` status only has an impact on whether the error on the field should be shown.
    }, [props.error, error, props.reset]);

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["useEffect"])(function () {
      if (props.submitCheck && props.submitCheck.shouldTrigger && !props.group) {
        // `focus()` first, otherwise `blur()` 
        // doesn't do anything (won't trigger onBlur)
        props.submitCheck.ref.current.focus();
        props.submitCheck.ref.current.blur();
      } // Show error if error exists, upon click of the submit button in the form

    }, [props.submitCheck && props.submitCheck.shouldTrigger]);
    /**
     * Checks whether to show error
     * 
     * Always show error if the controlled error is true;
     * Otherwise, show error only if internal error is true, the field has been touched,
     * and not asked to hide the error
     */


    var shouldShowError = function shouldShowError() {
      return props.error || touched && error && !hideError;
    };

    var multiStepFormContext = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["useContext"])(props.MultiStepFormContext || {});

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["useEffect"])(function () {
      // If in the context of a multi-step form, 
      // we want to notify if this step has "visible" errors.
      // The step is considered to have visible errors,
      // as long as any field in the form of this step has
      // visible errors (when error(s) should be actually shown)
      // 
      // This status can be further used by FormStepper to
      // display the error status of this particular step.
      if (multiStepFormContext && shouldShowError()) {
        multiStepFormContext.onStepError();
      }
    }, [shouldShowError()]);
    /**
     * Hook into onBlur to deal with validation
     */


    var onBlur = function onBlur(event) {
      if (!props.ignoreBlur) {
        // Eg.: used by Dropdown
        setTouched(true); // considered as `touched` upon onBlur

        setHideError(false); // do not need to hide the error anymore upon onBlur
      }

      hasBeenOnBlurBefore.current = true;
      var hasErrorNow = hasError(event && event.target.value); // check if value has error upon onBlur

      if (!error && hasErrorNow) {
        // if there was no internal error, but there is one now
        // set internal error true (so the error will be shown due to `touched` true and `hideError` false)
        setError(hasErrorNow);
      } else if (error && !hasErrorNow) {
        // if there was an internal error, but there isn't now
        setError(false); // set internal error false
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["b"
      /* isFunction */
      ])(props.onBlur) && props.onBlur(event); // call component's onBlur
    };
    /**
     * Hook into onChange to deal with validation
     */


    var onChange = function onChange(event) {
      var skipTouched = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false; // if already touched or if `touched` status is irrelevant, check if the updated value has error

      var _error = hasError(event && event.target.value);

      if (_error) {
        // Set internal error true
        // (note this won't affect the value of `error` below as it's async)
        setError(_error);
      } else {
        // Set internal error false in all other cases 
        // (note this won't affect the value of `error` below as it's async)
        setError(false);

        if (props.doubleCheck) {
          // Eg: GelTextInput needs double check if wrapped by GelNumberInput
          // Eg: Deals with entering letter or '.' in GelNumberInput when the value is ''.
          // Even though letter or '.' can pass the check of GelTextInput when value is '',
          // GelNumberInput will not notify parent of the value change, as this
          // value change is considered invalid by GelNumberInput, therefore a controlled 
          // GelNumberInput will still have value ''.
          //
          // We check the validity of the value here again in the next tick, so that
          // GelTextInput will still be able to pick up the fact that the value change did not
          // pass GelNumberInput and that the value is now still ''
          var timer = setTimeout(function () {
            if (!isUnmountedRef.current) {
              var _error2 = hasError(event && event.target.value);

              if (_error2) {
                setError(_error2);
              }
            }

            clearTimeout(timer);
          });
        }
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["b"
      /* isFunction */
      ])(props.onChange) && props.onChange(event); // call component's onChange
    };
    /**
     * Returns a caption array, taking into account the original caption (props.caption), 
     * error message for the internal error, and the status of the controlled and internal error
     */


    var getCaption = function getCaption() {
      if (shouldShowError()) {
        // if there is error (either controlled error or internal error, or both)
        var caption = []; // if there is controlled error - in which case `props.caption` can 
        // contain error message for the controlled error

        if (props.error) {
          if (!Array.isArray(props.caption)) {
            props.caption && caption.push(props.caption);
          } else {
            caption.push.apply(caption, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(props.caption));
          }
        } // and if there is internal error, put the internal error message ahead of 
        // the error message(s) for the controlled error
        //
        // Note that if there is no controlled error but there is internal error, 
        // the original caption (props.caption) won't be included in the returned caption array,
        // and only the error message for the internal error will be displayed.


        if (touched && error && props.errorMsg) {
          if (typeof error === 'string') {
            caption.unshift(props.errorMsg[error]);
          } else {
            caption.unshift(props.errorMsg);
          }
        }

        return caption;
      } // if no error needs showing, return the original `caption` but in the form of an array


      return !Array.isArray(props.caption) ? [props.caption] : props.caption;
    };

    return [onBlur, onChange, getCaption, shouldShowError];
  };

  var isControlled = function isControlled(prop) {
    return prop !== undefined;
  };
  /* harmony default export */


  __webpack_exports__["a"] = useValidator;
  /***/
},
/* 35 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "b", function () {
    return WINDOW_RESIZE_DEBOUNCE_TIME;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_debounce__ = __webpack_require__(12);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_debounce__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(2);

  var WINDOW_RESIZE_DEBOUNCE_TIME = 100;
  /**
   * Custom hook to make the component re-render when window size changes
   * Debouncing is used for better performance
   * 
   * @param {number} debounceTime - debounce time in ms
   */

  var useWindowSize = function useWindowSize() {
    var debounceTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : WINDOW_RESIZE_DEBOUNCE_TIME;

    var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])({
      // for SSR
      width: typeof window !== 'undefined' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["h"
      /* getWindowWidth */
      ])() : 0,
      height: typeof window !== 'undefined' ? window.innerHeight : 0
    }),
        _useState2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
        windowSize = _useState2[0],
        setWindowSize = _useState2[1];

    var changed = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(false);

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
      // won't be invoked in SSR
      // debounce the function
      var debouncedUpdateWindowSize = __WEBPACK_IMPORTED_MODULE_2_debounce___default()(function () {
        setWindowSize({
          // Note: cannot use `innerWidth`, because if content has 
          // large fixed width (causing horizontal scrollbar), 
          // `innerWidth` can be greater than `outerWidth`, and 
          // not reflect the true width of the window. In other words,
          // `innerWidth` may not be the actual content visible area.
          //
          // However, we use `innerHeight` because `innerHeight` is
          // the actual visible content area whereas `outerHeight` 
          // includes the browser headers at top
          width: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["h"
          /* getWindowWidth */
          ])(),
          height: window.innerHeight
        });
        changed.current = true;
      }, debounceTime); // add to `resize` event listener


      window.addEventListener('resize', debouncedUpdateWindowSize);
      return function () {
        // only upon unmount
        debouncedUpdateWindowSize.clear();
        window.removeEventListener('resize', debouncedUpdateWindowSize);
      };
    }, []); // only upon first render (mount)


    var result = [windowSize, changed.current];
    changed.current = false;
    return result;
  };
  /* harmony default export */


  __webpack_exports__["a"] = useWindowSize;
  /***/
},
/* 36 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  Object.defineProperty(__webpack_exports__, "__esModule", {
    value: true
  });
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__contexts__ = __webpack_require__(13);
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "GelAlertContextProvider", function () {
    return __WEBPACK_IMPORTED_MODULE_0__contexts__["a"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "AlertContext", function () {
    return __WEBPACK_IMPORTED_MODULE_0__contexts__["b"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "AlertContextConsumer", function () {
    return __WEBPACK_IMPORTED_MODULE_0__contexts__["c"];
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__hooks__ = __webpack_require__(14);
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "useSvgScale", function () {
    return __WEBPACK_IMPORTED_MODULE_1__hooks__["a"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "useForceUpdate", function () {
    return __WEBPACK_IMPORTED_MODULE_1__hooks__["b"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "usePressedState", function () {
    return __WEBPACK_IMPORTED_MODULE_1__hooks__["c"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "useQueryParams", function () {
    return __WEBPACK_IMPORTED_MODULE_1__hooks__["d"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "useRunOnce", function () {
    return __WEBPACK_IMPORTED_MODULE_1__hooks__["e"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "useValidator", function () {
    return __WEBPACK_IMPORTED_MODULE_1__hooks__["f"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "useIsUnmounted", function () {
    return __WEBPACK_IMPORTED_MODULE_1__hooks__["g"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "useIsMounted", function () {
    return __WEBPACK_IMPORTED_MODULE_1__hooks__["h"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "useUniqueId", function () {
    return __WEBPACK_IMPORTED_MODULE_1__hooks__["i"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "useWindowSize", function () {
    return __WEBPACK_IMPORTED_MODULE_1__hooks__["j"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "WINDOW_RESIZE_DEBOUNCE_TIME", function () {
    return __WEBPACK_IMPORTED_MODULE_1__hooks__["k"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "useEffectSkipTick", function () {
    return __WEBPACK_IMPORTED_MODULE_1__hooks__["l"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "useSetFocus", function () {
    return __WEBPACK_IMPORTED_MODULE_1__hooks__["m"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "useUnderlyingError", function () {
    return __WEBPACK_IMPORTED_MODULE_1__hooks__["n"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "useDebounce", function () {
    return __WEBPACK_IMPORTED_MODULE_1__hooks__["o"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "useRenderOnTop", function () {
    return __WEBPACK_IMPORTED_MODULE_1__hooks__["p"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "useScrollToScreenTop", function () {
    return __WEBPACK_IMPORTED_MODULE_1__hooks__["q"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "useLayoutEffect", function () {
    return __WEBPACK_IMPORTED_MODULE_1__hooks__["r"];
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(15);
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "accessibleHiddenStyle", function () {
    return __WEBPACK_IMPORTED_MODULE_2__styles__["a"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "fixedAccessibleHiddenStyle", function () {
    return __WEBPACK_IMPORTED_MODULE_2__styles__["b"];
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(2);
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "makeEnum", function () {
    return __WEBPACK_IMPORTED_MODULE_3__utils__["a"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "isFunction", function () {
    return __WEBPACK_IMPORTED_MODULE_3__utils__["b"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "isInIE", function () {
    return __WEBPACK_IMPORTED_MODULE_3__utils__["c"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "roundToDecimals", function () {
    return __WEBPACK_IMPORTED_MODULE_3__utils__["d"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "isOnServer", function () {
    return __WEBPACK_IMPORTED_MODULE_3__utils__["e"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "setCaretPos", function () {
    return __WEBPACK_IMPORTED_MODULE_3__utils__["f"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "getCaretPos", function () {
    return __WEBPACK_IMPORTED_MODULE_3__utils__["g"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "getWindowWidth", function () {
    return __WEBPACK_IMPORTED_MODULE_3__utils__["h"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "ButtonUtils", function () {
    return __WEBPACK_IMPORTED_MODULE_3__utils__["i"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "GelFlexContainer", function () {
    return __WEBPACK_IMPORTED_MODULE_3__utils__["j"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "GelFlexItem", function () {
    return __WEBPACK_IMPORTED_MODULE_3__utils__["k"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "LEFT_MOUSE_BUTTON", function () {
    return __WEBPACK_IMPORTED_MODULE_3__utils__["l"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "SPACE", function () {
    return __WEBPACK_IMPORTED_MODULE_3__utils__["m"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "ENTER", function () {
    return __WEBPACK_IMPORTED_MODULE_3__utils__["n"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "ARROW_LEFT", function () {
    return __WEBPACK_IMPORTED_MODULE_3__utils__["o"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "ARROW_RIGHT", function () {
    return __WEBPACK_IMPORTED_MODULE_3__utils__["p"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "ARROW_UP", function () {
    return __WEBPACK_IMPORTED_MODULE_3__utils__["q"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "ARROW_DOWN", function () {
    return __WEBPACK_IMPORTED_MODULE_3__utils__["r"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "TAB", function () {
    return __WEBPACK_IMPORTED_MODULE_3__utils__["s"];
  });
  /***/

},
/* 37 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return ButtonUtils;
  }); // TODO: make enums

  /**
   * Gets the button size (object key to look for in the button theme)
   */


  var getSize = function getSize(xlarge, large, medium, small, xsmall) {
    if (xlarge) return 'ExtraLarge';
    if (large) return 'Large';
    if (medium) return 'Medium';
    if (small) return 'Small';
    if (xsmall) return 'ExtraSmall';
    throw 'button size not found';
  };
  /**
   * Gets the button type (object key to look for in the button theme)
   */


  var getType = function getType(primary, secondary, tertiary, checkbox, radio) {
    if (primary) return 'Primary';
    if (secondary) return 'Secondary';
    if (tertiary) return 'Tertiary';
    if (checkbox || radio) return 'Toggle';
    throw 'button type not found';
  };
  /**
   * Gets the button state (object key to look for in the button theme)
   */


  var getState = function getState(focus, active, hover, disalbed) {
    if (disalbed) return 'Disabled';
    if (active) return 'Active';
    if (hover) return 'Hover'; // focus is true ONLY when the button is tabbed in and when the button is not in active or pressed state

    if (focus) return 'Focus';
    return null;
  }; // TODO: relocate it to themeUtil?

  /**
   * Gets svg filter (iconColor) for the icon of button as per button subtype and state
   * 
   * Button has 4 subtypes (Default, Error, Inverse, InverseError)
   * and each subtype has 5 states (Normal, Focus, Active, Hover, Disabled)
   * 
   * For normal state ('<-' means overriding): 
   *   default <- error
   *   default <- inverse
   *   default <- inverse <- inverse error
   * 
   * For other states ('<-' means overriding): 
   *   default <- default[state] 
   *   default <- default[state] <- error <- error[state] 
   *   default <- default[state] <- inverse <- inverse[state]
   *   default <- default[state] <- inverse <- inverse[state] <- inverse error <- inverse error[state]
   */
  // const getIconSvgFilter = ({ 
  //   theme, primary, secondary, tertiary, focus, active, hover, disabled, error, inverse 
  // }) => {
  //   let iconColor;
  //   if (theme && theme.Button) { 
  //     const type = getType(primary, secondary, tertiary);
  //     const state = getState(focus, active, hover, disabled); // normal state is when state is null
  //     const buttonStyle = theme.Button[type];
  //     if (buttonStyle) {
  //       // All default to the `iconColor` of the normal state of default subtype
  //       iconColor = buttonStyle.iconColor;
  //       if (state && buttonStyle[state] && buttonStyle[state].iconColor) {
  //         iconColor = buttonStyle[state].iconColor;
  //       }
  //       if (error && !inverse) { // error subtype
  //         if (buttonStyle.Error && buttonStyle.Error.iconColor) {
  //           iconColor = buttonStyle.Error.iconColor;
  //           if (state && buttonStyle.Error[state] && 
  //             buttonStyle.Error[state].iconColor
  //           ) {
  //             iconColor = buttonStyle.Error[state].iconColor;
  //           }
  //         }
  //       } else if (inverse) { 
  //         if (buttonStyle.Inverse && buttonStyle.Inverse.iconColor) { 
  //           // inverse subtype
  //           iconColor = buttonStyle.Inverse.iconColor;
  //           if (state && buttonStyle.Inverse[state] && 
  //             buttonStyle.Inverse[state].iconColor
  //           ) {
  //             iconColor = buttonStyle.Inverse[state].iconColor;
  //           }
  //           if (error) { // inverse error subtype
  //             if (buttonStyle.Inverse && 
  //               buttonStyle.Inverse.Error && 
  //               buttonStyle.Inverse.Error.iconColor
  //             ) {
  //               iconColor = buttonStyle.Inverse.Error.iconColor;
  //               if (state && buttonStyle.Inverse.Error[state] && 
  //                 buttonStyle.Inverse.Error[state].iconColor
  //               ) {
  //                 iconColor = buttonStyle.Inverse.Error[state].iconColor;
  //               }
  //             }  
  //           }
  //         }
  //       }
  //     }
  //   }
  //   return `filter-${iconColor.toUpperCase()}`;
  // };


  var ButtonUtils = {
    getSize: getSize,
    getType: getType,
    getState: getState //  getIconSvgFilter

  };
  /***/
},
/* 38 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return setCaretPos;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "b", function () {
    return getCaretPos;
  }); // Credits: http://blog.vishalon.net/index.php/javascript-getting-and-setting-caret-position-in-textarea/


  var setCaretPos = function setCaretPos(ctrl, pos) {
    if (ctrl.setSelectionRange) {
      // Modern browsers
      ctrl.focus();
      ctrl.setSelectionRange(pos, pos);
    } else if (ctrl.createTextRange) {
      // IE8 and below
      var range = ctrl.createTextRange();
      range.collapse(true);
      range.moveEnd('character', pos);
      range.moveStart('character', pos);
      range.select();
    }
  };

  var getCaretPos = function getCaretPos(ctrl) {
    if (ctrl.setSelectionRange) {
      // Modern browsers
      return ctrl.selectionStart;
    } else if (ctrl.createTextRange) {
      // IE8 and below
      ctrl.focus(); // To get cursor position, get empty selection range

      var selection = document.selection.createRange(); // Move selection start to 0 position

      selection.moveStart('character', -ctrl.value.length); // The caret position is selection length

      return selection.text.length;
    }

    console.error('getCaretPos - returning -1');
    return -1;
  };
  /***/

},
/* 39 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return FlexContainer;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "b", function () {
    return FlexItem;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__emotion_styled__ = __webpack_require__(49);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__emotion_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__emotion_styled__);

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }
  /**
   * Flexbox container 
   */


  var FlexContainer = __WEBPACK_IMPORTED_MODULE_1__emotion_styled___default.a.div(function (_ref) {
    var _ref$display = _ref.display,
        display = _ref$display === void 0 ? 'flex' : _ref$display,
        _ref$flexDirection = _ref.flexDirection,
        flexDirection = _ref$flexDirection === void 0 ? 'row' : _ref$flexDirection,
        _ref$alignItems = _ref.alignItems,
        alignItems = _ref$alignItems === void 0 ? 'flex-start' : _ref$alignItems,
        _ref$justifyContent = _ref.justifyContent,
        justifyContent = _ref$justifyContent === void 0 ? 'space-between' : _ref$justifyContent,
        _ref$flexWrap = _ref.flexWrap,
        flexWrap = _ref$flexWrap === void 0 ? false : _ref$flexWrap,
        _ref$marginTop = _ref.marginTop,
        marginTop = _ref$marginTop === void 0 ? 15 : _ref$marginTop,
        _ref$marginBottom = _ref.marginBottom,
        marginBottom = _ref$marginBottom === void 0 ? 15 : _ref$marginBottom;
    return _objectSpread({
      display: display,
      flexDirection: flexDirection,
      alignItems: alignItems,
      justifyContent: justifyContent,
      marginTop: marginTop,
      marginBottom: marginBottom
    }, flexWrap && {
      flexWrap: 'wrap'
    });
  });
  /**
   * Flexbox item
   */


  var FlexItem = __WEBPACK_IMPORTED_MODULE_1__emotion_styled___default.a.div(function (_ref2) {
    var _ref2$flexGrow = _ref2.flexGrow,
        flexGrow = _ref2$flexGrow === void 0 ? 0 : _ref2$flexGrow,
        _ref2$flexShrink = _ref2.flexShrink,
        flexShrink = _ref2$flexShrink === void 0 ? 1 : _ref2$flexShrink,
        _ref2$flexBasis = _ref2.flexBasis,
        flexBasis = _ref2$flexBasis === void 0 ? 'auto' : _ref2$flexBasis,
        paddingRight = _ref2.paddingRight;
    return {
      flexGrow: flexGrow,
      flexShrink: flexShrink,
      flexBasis: flexBasis,
      paddingRight: paddingRight
    };
  });
  /***/

},
/* 40 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony default export */

  __webpack_exports__["a"] = function () {
    return window.innerWidth <= window.outerWidth ? window.innerWidth : window.outerWidth;
  };
  /***/

},
/* 41 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /**
   * Checks if the target is an executable function,
   * Eg: checking if an event handler is provided (by parent) before executing it
   */

  /* harmony default export */

  __webpack_exports__["a"] = function (fn) {
    return typeof fn === 'function';
  };
  /***/

},
/* 42 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__is_on_server__ = __webpack_require__(11);
  /* harmony default export */


  __webpack_exports__["a"] = function () {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__is_on_server__["a"
    /* default */
    ])()) {
      // for SSR
      return window.document.documentMode;
    }

    return false;
  };
  /***/

},
/* 43 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return LEFT_MOUSE_BUTTON;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "b", function () {
    return SPACE;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "c", function () {
    return ENTER;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "d", function () {
    return ARROW_LEFT;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "e", function () {
    return ARROW_RIGHT;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "f", function () {
    return ARROW_UP;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "g", function () {
    return ARROW_DOWN;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "h", function () {
    return TAB;
  });

  var LEFT_MOUSE_BUTTON = 1;
  var SPACE = 32;
  var ENTER = 13;
  var ARROW_LEFT = 37;
  var ARROW_RIGHT = 39;
  var ARROW_UP = 38;
  var ARROW_DOWN = 40;
  var TAB = 9;
  /***/
},
/* 44 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony default export */

  __webpack_exports__["a"] = function () {
    for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
      values[_key] = arguments[_key];
    }

    return Object.freeze(values.reduce(function (prev, curr) {
      prev[curr] = Symbol(curr);
    }, {}));
  };
  /***/

},
/* 45 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony default export */

  __webpack_exports__["a"] = function (value, numOfDecimals) {
    var factor = 1;

    for (var i = 0; i < numOfDecimals; i++) {
      factor = factor * 10;
    }

    return (Math.round(value * factor) / factor).toFixed(numOfDecimals).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };
  /***/

},
/* 46 */

/***/
function (module, exports) {
  /**
   * Convert array of 16 byte values to UUID string format of the form:
   * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
   */
  var byteToHex = [];

  for (var i = 0; i < 256; ++i) {
    byteToHex[i] = (i + 0x100).toString(16).substr(1);
  }

  function bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = byteToHex; // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4

    return [bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]]].join('');
  }

  module.exports = bytesToUuid;
  /***/
},
/* 47 */

/***/
function (module, exports) {
  // Unique ID creation requires a high quality random # generator.  In the
  // browser this is a little complicated due to unknown quality of Math.random()
  // and inconsistent support for the `crypto` API.  We do the best we can via
  // feature-detection
  // getRandomValues needs to be invoked in a context where "this" is a Crypto
  // implementation. Also, find the complete implementation of crypto on IE11.
  var getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);

  if (getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

    module.exports = function whatwgRNG() {
      getRandomValues(rnds8);
      return rnds8;
    };
  } else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var rnds = new Array(16);

    module.exports = function mathRNG() {
      for (var i = 0, r; i < 16; i++) {
        if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
        rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
      }

      return rnds;
    };
  }
  /***/

},
/* 48 */

/***/
function (module, exports, __webpack_require__) {
  var rng = __webpack_require__(47);

  var bytesToUuid = __webpack_require__(46);

  function v4(options, buf, offset) {
    var i = buf && offset || 0;

    if (typeof options == 'string') {
      buf = options === 'binary' ? new Array(16) : null;
      options = null;
    }

    options = options || {};
    var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

    if (buf) {
      for (var ii = 0; ii < 16; ++ii) {
        buf[i + ii] = rnds[ii];
      }
    }

    return buf || bytesToUuid(rnds);
  }

  module.exports = v4;
  /***/
},
/* 49 */

/***/
function (module, exports) {
  module.exports = require("@emotion/styled");
  /***/
},
/* 50 */

/***/
function (module, exports) {
  module.exports = require("react-router-dom");
  /***/
}
/******/
]);